import { Component, Input } from '@angular/core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
// import { catLifeStages, dogLifeStages } from '../life-stages';

@Component({
  selector: 'lib-documents-modal',
  templateUrl: './documents-modal.component.html',
  styleUrls: ['./documents-modal.component.css']
})
export class DocumentsModalComponent {
  @Input() accountId!: string;

  itemType: 'Document' | 'Link' = '' as any; 

  // Document fields
  selectedFile: File | null = null;
  name = '';
  docType = '';
  species = '';
  // Allow lifeStage to be either a string (when species === 'All')
  // or an array (when species is Dog or Cat)
  // lifeStage: string | string[] = '';

  // Link fields
  linkName = '';
  linkUrl = '';
  linkDocType = '';
  linkSpecies = '';
  // linkLifeStage: string | string[] = '';

  // catLifeStages = catLifeStages;
  // dogLifeStages = dogLifeStages;

  constructor(public activeOffcanvas: NgbActiveOffcanvas) {}

  onFileSelected(event: any) {
    this.selectedFile = event.target.files?.[0] || null;
  }

  onSubmit(form: NgForm) {
    // Mark all fields as touched so errors display.
    form.form.markAllAsTouched();
    if (form.invalid) {
      return;
    }
    
    if (this.itemType === 'Document') {
      const userData = {
        accountId: this.accountId,
        itemType: 'Document',
        document: {
          file: this.selectedFile,
          name: this.name,
          docType: this.docType,
          species: this.species,
          // lifeStage: this.lifeStage
        },
        link: null
      };
      this.activeOffcanvas.close(userData);
    } else if (this.itemType === 'Link') {
      const userData = {
        accountId: this.accountId,
        itemType: 'Link',
        link: {
          name: this.linkName,
          link: this.linkUrl,
          docType: this.linkDocType,
          species: this.linkSpecies || null,
          // lifeStage: this.linkLifeStage
        },
        document: null
      };
      this.activeOffcanvas.close(userData);
    }
  }  

  // onSpeciesChange() {
  //   if (this.species === 'All') {
  //     // Single selection mode when "All" is chosen in species.
  //     this.lifeStage = 'All';
  //   } else {
  //     // For Dog or Cat, initialize as an empty array for multi-selection.
  //     this.lifeStage = [];
  //   }
  // }
  
  // onLinkSpeciesChange() {
  //   if (this.linkSpecies === 'All') {
  //     this.linkLifeStage = 'All';
  //   } else {
  //     this.linkLifeStage = [];
  //   }
  // }   

  // Change handler for the Document life stage selection.
  // onLifeStageChange() {
  //   if ((this.species === 'Dog' || this.species === 'Cat') && Array.isArray(this.lifeStage)) {
  //     // Determine the "All" value for the chosen species.
  //     const allOption = this.species === 'Dog' ? 'speciesDogAll' : 'speciesCatAll';
  //     // Enforce exclusivity: if the "All" option is selected alongside any other option,
  //     // then keep only "All".
  //     if (this.lifeStage.includes(allOption) && this.lifeStage.length > 1) {
  //       this.lifeStage = [allOption];
  //     }
  //   }
  // }
  
  // Change handler for the Link life stage selection.
  // onLinkLifeStageChange() {
  //   if ((this.linkSpecies === 'Dog' || this.linkSpecies === 'Cat') && Array.isArray(this.linkLifeStage)) {
  //     const allOption = this.linkSpecies === 'Dog' ? 'speciesDogAll' : 'speciesCatAll';
  //     if (this.linkLifeStage.includes(allOption) && this.linkLifeStage.length > 1) {
  //       this.linkLifeStage = [allOption];
  //     }
  //   }
  // }  

  onCancel() {
    this.activeOffcanvas.dismiss();
  }
}
